import Swiper from 'swiper';
import { Pagination, Autoplay, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

const phone = 767;
const tabMid = 900;
const tabBig = 1260;

const initialSpaceBetween = 6;

const initSwiper = (str, config) => {
  return new Swiper(str, {
    modules: [Pagination],
    pagination: {
      el: `${str} .swiper-pagination`,
      clickable: true,
      renderBullet: (i) =>
        `<span class="swiper-pagination-bullet ${i === 0 ? 'swiper-pagination-bullet-active' : ''}"></span>`,
    },
    ...config,
  });
};

window.initSwiper = initSwiper;

initSwiper('.hero-swiper', {
  modules: [Pagination, Autoplay],
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
  },
  speed: 1000,
});

initSwiper('.trend-section-swiper', {
  modules: [Pagination],
  slidesPerView: 2,
  spaceBetween: initialSpaceBetween,
  breakpoints: {
    [tabMid]: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
  },
});

initSwiper('.swiper--content--cards', {
  modules: [Pagination],
  slidesPerView: 2,
  spaceBetween: 6,
});

initSwiper('.top-swiper-blog', {
  slidesPerView: 1,
  spaceBetween: initialSpaceBetween,
  breakpoints: {
    [tabBig]: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    [tabMid]: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    [phone]: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },
});

initSwiper('.top-swiper', {
  slidesPerView: 2,
  spaceBetween: initialSpaceBetween,
  breakpoints: {
    [tabBig]: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    [tabMid]: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    [phone]: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

initSwiper('.procedures-swiper', {
  slidesPerView: 2,
  spaceBetween: initialSpaceBetween,
  breakpoints: {
    [tabBig]: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    [tabMid]: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    [phone]: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

initSwiper('.reviews-swiper', {
  slidesPerView: 1,
  spaceBetween: initialSpaceBetween,
  breakpoints: {
    [tabBig]: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    [tabMid]: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    [phone]: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },
});

initSwiper('.club-swiper', {
  slidesPerView: 1,
  spaceBetween: initialSpaceBetween,
  breakpoints: {
    [tabBig]: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    [tabMid]: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    [phone]: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

const swiperThumbs = new Swiper('.single-swiper-thumbs', {
  spaceBetween: initialSpaceBetween,
  slidesPerView: 4,
  spaceBetween: 8,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  direction: 'horizontal',
  breakpoints: {
    [tabMid]: {
      direction: 'vertical',
      slidesPerView: 5,
    },
  },
});

new Swiper('.also-swiper', {
  modules: [Autoplay],
  spaceBetween: initialSpaceBetween,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 3000,
  },
});

initSwiper('.single-swiper', {
  modules: [Thumbs, Pagination],
  spaceBetween: initialSpaceBetween,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  preventInteractionOnTransition: true,
  thumbs: {
    swiper: swiperThumbs,
  },
});
